import React from 'react';

import { StyleSheet, View } from 'react-native';

import { ZIndex, primitive, spacing } from 'styles/constants';

interface SimplePromoRibbonProps {
  message: React.ReactElement;
  rounded?: boolean;
}

export const SimplePromoRibbon: React.FC<SimplePromoRibbonProps> = ({
  message,
  rounded = false,
}) => (
  <View style={[styles.ribbonContent, rounded && styles.rounded]}>
    <View style={styles.ribbonWrapper}>{message}</View>
  </View>
);

const styles = StyleSheet.create({
  ribbonContent: {
    zIndex: ZIndex.NORMAL,
    backgroundColor: primitive.$meltyYellow,
    height: spacing.$8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rounded: {
    borderRadius: primitive.$borderRadius,
  },
  ribbonWrapper: {
    zIndex: ZIndex.MAX,
    justifyContent: 'center',
    width: '100%',
  },
});
